import { render, staticRenderFns } from "./behaviors-chart.vue?vue&type=template&id=72189748&"
import script from "./behaviors-chart.vue.js?vue&type=script&lang=js&"
export * from "./behaviors-chart.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports